import { MethodType } from '../constants/MethodType'
const api = require('./api')

export const fetchUserCountUnderGroup = (id, params) => api.request(1, `/getNowUserCount/${id}`, MethodType.GET, params)

export const fetchBrandCountUnderGroup = (id, params) => api.request(1, `/getNowBrandCount/${id}`, MethodType.GET, params)

export const fetchSegmentCountUnderGroup = (id, params) => api.request(1, `/getNowSegmentCountByGroup/${id}`, MethodType.GET, params)

export const fetchSegmentCountUnderBrand = (id, params) => api.request(1, `/getNowSegmentCountByBrand/${id}`, MethodType.GET, params)

export const fetchTargetCountUnderGroup = (id, params) => api.request(1, `/getNowTargetingCountByGroup/${id}`, MethodType.GET, params)
